import { render, staticRenderFns } from "./TheTopbar.vue?vue&type=template&id=0ca53267&scoped=true"
import script from "./TheTopbar.vue?vue&type=script&lang=js"
export * from "./TheTopbar.vue?vue&type=script&lang=js"
import style0 from "./TheTopbar.vue?vue&type=style&index=0&id=0ca53267&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca53267",
  null
  
)

export default component.exports